export default __webpack_public_path__ + "static/media/o0494037014077419118.a158577a.png";